<template>
    <b-tabs v-if="actif" v-model="tab_index" >
        <b-tab :title="column.name" :title-item-class="(!column.hidden && (!column.only_if_no_empty || obj[column.name])) ? '' : 'd-none'" v-for="(column, idx) in action_columns" :key="idx">
            <br />
            <b-textarea v-if="column.type == 'textarea'" :rows="10" @change="update(column.name, obj[column.name])" v-model="obj[column.name]" />
            <b-input v-if="column.type == 'text'" :rows="10" @change="update(column.name, obj[column.name])" v-model="obj[column.name]" />
            <ace_editor 
                v-if="column.type == 'json' && idx == tab_index && column.picking != true" 
                :height="500" 
                @update="update(column.name, $event)" 
                mode="json" 
                :code="obj[column.name] ? JSON.stringify(JSON.parse(obj[column.name].replaceAll('\\n', '\n')), null, '   ') : ''">
            </ace_editor>
            <div v-if="column.type == 'json' && column.picking == true">
                <json_editor :multiple="column.multiple || false" :config_columns="column.columns || {}" :index="data[index]" :action_columns_picking="action_columns_picking[block_i + '_' + block_j + ' ' + idx] || {}" :id_action='block_i + "_" + block_j' :data='obj[column.name]' @get="get_json_editor(idx, ...arguments)" />
                <div>Mapping <b-button variant="link" @click="get_actions_column_mapping(idx)">Mettre à jour</b-button></div>
                <array_editor :emit="false" :data_reference="obj[column.name]" :ref="'array' + idx" :start_data="column.picking_columns || []"
                    :columns='[
                        {name: "from", libelle: "Origine", type: "text"},
                        {name: "to", libelle: "Destination", type: "text"},
                ]'/>
            </div>
        </b-tab>
    </b-tabs>
</template>

<script>
import _ from 'lodash';

var clone = require("clone");

import uniqueId from "lodash.uniqueid";
import ace_editor from "../ace_editor";
import json_editor from "../json_editor";
import array_editor from "../array_editor";

export default {
    name: "action_columns",
    components: {
        ace_editor,
        json_editor,
        array_editor
    },
    props: {
        action_columns: {
            default: () => []
        },
        data: {
            default: () => {}
        },
        block_i: {},
        block_j: {},
        action_columns_picking: {
            default: () => {}
        },
        index: {}
    },
    watch:
    {
        action_columns_picking: {
            deep: true,
            async handler() {
                console.log("action_columns_picking")
            }            
        },
        data: 
        {
            immediate: true,
            deep: true,
            async handler() {
                this.obj = clone(this.data);
                /*var keys = Object.keys(this.obj);
                for (var i = 0; i < keys.length; i++)
                {
                    this.$set(this.obj, keys[i], this.obj[keys[i]])
                }*/
            }
        }
    },
    data: function () {
        return {
            obj: "",
            id: uniqueId(),
            actif: true,
            tab_index: 0,
        };
    },
    methods: {
        get_actions_column_mapping(idx)
        {
            console.log("get_actions_column_mapping")
            var params = this.$refs["array" + idx][0].get();
            //console.log(JSON.stringify(params))
            this.$emit("update_actions_column_mapping", idx, params.data, params.old_data);

        },
        update_actions_column_mapping(idx, mapping_column, old_mapping_column)
        {
            console.log("update_actions_column_mapping")
            //console.log(old_mapping_column)
            this.$emit("update_actions_column_mapping", idx, mapping_column, old_mapping_column)
        },
        get_json_editor(idx, data, idx_json_value, id_json, multiple)
        {
            this._tab_index = this.tab_index;
            //console.log(idx)
            //console.log(data)
            var mapping = this.$refs["array" + idx][0].save();
            /*if (!mapping || mapping.length == 0)
                this.$emit("update_obj",data, idx_json_value, id_json, this.block_i + "_" + this.block_j, idx, clone(data));
            else
            {*/
            /*var obj = [];
            for (var i = 0; i < mapping.length; i++)
            {
                if (!mapping[i].from)
                    obj[mapping[i].to] = JSON.stringify(data);
                else if (data.hasOwnProperty(mapping[i].from))
                    obj[mapping[i].to] = data[mapping[i].from];
            }*/
            this.$emit("update_obj", mapping, idx_json_value, id_json, this.block_i + "_" + this.block_j, idx, clone(data), multiple);
            /*}*/
        },
        update(column, value)
        {
            console.log("update")
            this.$emit("update", column, value);
        }
    },
    mounted: function () {
        console.log("mounted")
    },
}

</script>